var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M100.25 11.133c-34.079 0-61.706 27.627-61.706 61.706 0 26.017 37.063 84.877 54.079 111.271 4.088 6.341 10.566 6.341 14.655 0 17.016-26.394 54.179-85.254 54.179-111.271-.001-34.079-27.128-61.706-61.207-61.706zm-.25 94.266c-18.3 0-33.135-14.835-33.135-33.135 0-18.3 14.835-33.135 33.135-33.135 18.3 0 33.135 14.835 33.135 33.135 0 18.3-14.835 33.135-33.135 33.135z",
    id: "Predloha"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.4df565cb4aafee353e937c643ed97909.svg";
export { ForwardRef as ReactComponent };